import { TimingMarker } from "@faire/web--source/common/timings/TimingMarker";
import { useRefFrom } from "@faire/web--source/ui/hooks/useRefFrom";
import { useRef } from "react";

import { useSearchSuggestionsUnthrottledQueryString } from "@faire/retailer/features/SearchSuggestions-v2/DataFetching/__internal__/useSearchSuggestionsUnthrottledQueryStringContext";
import { eventTimeStampToRelative } from "@faire/retailer/features/SearchSuggestions-v2/utils";

export const useSearchSuggestionsStartTimingForQuery = (
  queryString: string | undefined
) => {
  const timingMap = useTimingMap();
  const timingForQuery = timingMap.get(queryString ?? undefined);
  if (timingForQuery === undefined) {
    return undefined;
  }

  return new TimingMarker(timingForQuery);
};

const useTimingMap = () => {
  const unthrottledQueryString = useSearchSuggestionsUnthrottledQueryString();
  const timingMap = useRefFrom(() => new Map<string | undefined, number>());
  const prevQuery = useRef<string | undefined>(undefined);

  // Can't utilise useEffect here given that it runs only after render,
  // but we need to add to the timingMap before the render
  if (prevQuery.current !== unthrottledQueryString) {
    const timing = eventTimeStampToRelative();
    timingMap.current.set(unthrottledQueryString, timing);
    prevQuery.current = unthrottledQueryString;
  }

  return timingMap.current;
};
